document.addEventListener('DOMContentLoaded', function() {
  var field = document.getElementById('personalisation-field');
  if (!field) return;

  function getCheckedValue() {
    var input = document.querySelector('input[type="radio"][name^="Personalisation"]:checked');
    return input ? input.value : null;
  }

  function updateVisibility() {
    var val = getCheckedValue();
    field.style.display = (!val || val === 'With Personalisation') ? 'block' : 'none';
  }

  // Initial state
  updateVisibility();

  // Listen for label clicks (theme updates radio state but doesn't fire change events)
  document.addEventListener('click', function(e) {
    var label = e.target.closest('label');
    if (label && label.htmlFor && label.htmlFor.includes('template--')) {
      setTimeout(updateVisibility, 10);
    }
  });
});

